/* Sven & Son — Notify me when back in stock
 * Pairs with snippets/sven-bis-notify.liquid + assets/sven-bis.css.
 *
 * On submit:
 *  1. (optional) Klaviyo client subscription → SMS marketing consent (only if the shopper ticks the SMS box
 *     and an SMS list ID is configured).
 *  2. Klaviyo client back-in-stock subscription → "Subscribed to Back in Stock" metric. Klaviyo's Back in
 *     Stock flow sends the alert automatically when Shopify inventory for that variant comes back.
 *  3. Klaviyo client events: "Requested Back in Stock Alert" on the shopper's profile (reporting), and
 *     "Back in Stock Sales Lead" on the sales@svenandson.com profile → triggers the branded sales-alert
 *     email flow with full product/variant/contact details (no internal-alert opt-in needed).
 *  4. (optional) HubSpot Forms API submission → creates/updates the contact in HubSpot for sales follow-up.
 *
 * Only step 2 must succeed for the shopper to see the success state; 1/3/4 are best-effort and logged.
 */
(function () {
  'use strict';
  if (window.SvenBIS && window.SvenBIS.__loaded) return;

  var KLAVIYO_REVISION = '2025-07-15';
  var KLAVIYO_BASE = 'https://a.klaviyo.com/client/';
  var EVENT_NAME = 'Requested Back in Stock Alert';
  // Logged on the sales inbox's own Klaviyo profile so a normal flow email (full HTML, no internal-alert
  // opt-in) can notify the sales team about every lead.
  var SALES_EVENT_NAME = 'Back in Stock Sales Lead';
  var DEFAULT_SALES_EMAIL = 'sales@svenandson.com';
  var STORE_KEY = 'svenBisSubscribed';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function log() { try { console.info.apply(console, ['[sven-bis]'].concat([].slice.call(arguments))); } catch (e) {} }
  function warn() { try { console.warn.apply(console, ['[sven-bis]'].concat([].slice.call(arguments))); } catch (e) {} }

  /* ---------- helpers ---------- */
  function normalizePhone(raw) {
    if (!raw) return '';
    var s = ('' + raw).trim();
    if (!s) return '';
    var plus = s.charAt(0) === '+';
    var d = s.replace(/\D/g, '');
    if (plus) return (d.length >= 10 && d.length <= 15) ? '+' + d : null;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return null;
  }

  function detectKlaviyoKey() {
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var m = (scripts[i].getAttribute('src') || '').match(/company_id=([A-Za-z0-9]{6})/);
      if (m) return m[1];
    }
    try {
      if (window.klaviyoModulesObject && window.klaviyoModulesObject.companyId) return window.klaviyoModulesObject.companyId;
    } catch (e) {}
    return '';
  }

  function readStore() {
    try { return JSON.parse(window.sessionStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeStore(map) {
    try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify(map)); } catch (e) {}
  }
  var memStore = readStore();

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function postJSON(url, body, headers) {
    var h = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    for (var k in (headers || {})) h[k] = headers[k];
    return fetch(url, { method: 'POST', headers: h, body: JSON.stringify(body) }).then(function (r) {
      if (r.ok) return r;
      return r.text().then(function (t) {
        var err = new Error('HTTP ' + r.status + ' ' + url);
        err.status = r.status; err.body = t;
        throw err;
      });
    });
  }

  function klaviyoPost(path, key, body) {
    return postJSON(KLAVIYO_BASE + path + '?company_id=' + encodeURIComponent(key), body, { revision: KLAVIYO_REVISION });
  }

  /* ---------- Klaviyo payloads ---------- */
  function bisPayload(email, phone, variantId, channels) {
    var attrs = { email: email };
    if (phone) attrs.phone_number = phone;
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: attrs } },
          channels: channels
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };
  }

  function smsConsentPayload(email, phone, listId) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Back in Stock Form (svenandson.com PDP)',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                phone_number: phone,
                subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
  }

  function eventPayload(email, phone, props, uniqueId) {
    var attrs = { email: email };
    if (phone) attrs.phone_number = phone;
    return {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          unique_id: uniqueId,
          metric: { data: { type: 'metric', attributes: { name: EVENT_NAME } } },
          profile: { data: { type: 'profile', attributes: attrs } }
        }
      }
    };
  }

  function salesLeadPayload(salesEmail, shopperEmail, phone, props, uniqueId) {
    var p = {};
    for (var k in props) p[k] = props[k];
    p.ShopperEmail = shopperEmail;
    p.ShopperPhone = phone || '';
    p.PriceFormatted = (typeof props.Price === 'number')
      ? '$' + props.Price.toLocaleString('en-US', { minimumFractionDigits: props.Price % 1 ? 2 : 0, maximumFractionDigits: 2 })
      : '';
    p.SubmittedAt = new Date().toISOString();
    return {
      data: {
        type: 'event',
        attributes: {
          properties: p,
          unique_id: uniqueId,
          metric: { data: { type: 'metric', attributes: { name: SALES_EVENT_NAME } } },
          profile: { data: { type: 'profile', attributes: { email: salesEmail } } }
        }
      }
    };
  }

  /* ---------- Instance ---------- */
  function Instance(el) {
    this.el = el;
    this.pdp = el.closest('.sven-pdp') || el.closest('[data-section-id]') || document;
    this.variants = {};
    try {
      var j = el.querySelector('[data-bis-variants]');
      this.variants = j ? JSON.parse(j.textContent) : {};
    } catch (e) { warn('variant JSON parse failed', e); }
    this.currentId = el.getAttribute('data-variant-id');
    this.email = el.querySelector('[data-bis-email]');
    this.phone = el.querySelector('[data-bis-phone]');
    this.sms = el.querySelector('[data-bis-sms]');
    this.smsWrap = el.querySelector('[data-bis-sms-wrap]');
    this.smsLegal = el.querySelector('[data-bis-sms-legal]');
    this.hp = el.querySelector('[data-bis-hp]');
    this.btn = el.querySelector('[data-bis-submit]');
    this.btnLabel = el.querySelector('[data-bis-btn-label]');
    this.msg = el.querySelector('[data-bis-msg]');
    this.form = el.querySelector('[data-bis-form]');
    this.success = el.querySelector('[data-bis-success]');
    this.successSub = el.querySelector('[data-bis-success-sub]');
    this.variantLabel = el.querySelector('[data-bis-variant-label]');
    this.defaultBtnText = this.btnLabel ? this.btnLabel.textContent : 'Notify Me';
    this.busy = false;
    this.bind();
    // Sync with whatever the section currently has selected (handles ?variant= deep links and
    // any variant switch that happened before this deferred script ran).
    var input = this.pdp.querySelector ? this.pdp.querySelector('#sven-variant-id, input[name="id"]') : null;
    this.setVariant((input && input.value) || this.currentId);
  }

  Instance.prototype.bind = function () {
    var self = this;
    this.btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.submit(); });
    [this.email, this.phone].forEach(function (inp) {
      if (!inp) return;
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); self.submit(); }
      });
      inp.addEventListener('input', function () { inp.removeAttribute('aria-invalid'); self.hideMsg(); });
    });
    if (this.phone) this.phone.addEventListener('input', function () { self.toggleSms(); });
    if (this.pdp && this.pdp.addEventListener) {
      this.pdp.addEventListener('sven:variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.id != null) self.setVariant(v.id, v);
      });
    }
  };

  Instance.prototype.toggleSms = function () {
    if (!this.smsWrap) return;
    var has = !!(this.phone && this.phone.value.trim());
    this.smsWrap.hidden = !has;
    if (this.smsLegal) this.smsLegal.hidden = !has;
    if (!has && this.sms) this.sms.checked = false;
  };

  Instance.prototype.setVariant = function (id, liveVariant) {
    id = id != null ? ('' + id) : this.currentId;
    var v = this.variants[id];
    var available;
    if (liveVariant && typeof liveVariant.available === 'boolean') available = liveVariant.available;
    else if (v) available = !!v.available;
    else available = true;
    this.currentId = id;
    this.el.setAttribute('data-variant-id', id);
    if (this.variantLabel) {
      var label = v && v.label ? v.label : (liveVariant && liveVariant.title) || '';
      this.variantLabel.textContent = label || this.el.getAttribute('data-product-title') || '';
    }
    this.el.hidden = !!available;
    this.hideMsg();
    if (!available && memStore[id]) this.showSuccess(memStore[id]);
    else this.showForm();
  };

  Instance.prototype.showForm = function () {
    if (this.form) this.form.hidden = false;
    if (this.success) this.success.hidden = true;
  };

  Instance.prototype.showSuccess = function (email, texted) {
    if (this.form) this.form.hidden = true;
    if (this.success) this.success.hidden = false;
    if (this.successSub) {
      var v = this.variants[this.currentId];
      var label = v && v.label ? v.label : 'this item';
      this.successSub.textContent = 'We’ll email ' + (email || 'you') + (texted ? ' and text you' : '') + ' the moment ' + label + ' is back in stock.';
    }
  };

  Instance.prototype.showMsg = function (text) {
    if (!this.msg) return;
    this.msg.textContent = text;
    this.msg.hidden = false;
  };
  Instance.prototype.hideMsg = function () { if (this.msg) { this.msg.hidden = true; this.msg.textContent = ''; } };

  Instance.prototype.setBusy = function (on) {
    this.busy = on;
    this.btn.disabled = !!on;
    if (this.btnLabel) this.btnLabel.textContent = on ? 'Signing you up…' : this.defaultBtnText;
  };

  Instance.prototype.focusFirst = function () {
    var self = this;
    this.el.classList.remove('is-flash'); void this.el.offsetWidth; this.el.classList.add('is-flash');
    try { this.el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { this.el.scrollIntoView(); }
    setTimeout(function () { if (self.email && !self.form.hidden) { try { self.email.focus({ preventScroll: true }); } catch (e) { self.email.focus(); } } }, 450);
  };

  Instance.prototype.buildProps = function (v, phone, smsOptIn) {
    var el = this.el;
    var url = el.getAttribute('data-product-url') + '?variant=' + this.currentId;
    return {
      ProductName: el.getAttribute('data-product-title'),
      ProductID: el.getAttribute('data-product-id'),
      ProductHandle: el.getAttribute('data-product-handle'),
      ProductType: el.getAttribute('data-product-type'),
      VariantID: this.currentId,
      VariantName: v ? v.label || v.title : '',
      SKU: v ? v.sku : '',
      Size: v ? v.option1 : null,
      Option2: v ? v.option2 : null,
      Option3: v ? v.option3 : null,
      Price: v && typeof v.price === 'number' ? (v.price / 100) : null,
      URL: url,
      ImageURL: (v && v.image) || el.getAttribute('data-product-image') || '',
      PageTemplate: el.getAttribute('data-template'),
      PhoneProvided: !!phone,
      PhoneNumber: phone || '',
      SMSOptIn: !!smsOptIn,
      Brand: 'Sven & Son',
      Source: 'PDP back-in-stock form'
    };
  };

  Instance.prototype.submit = function () {
    if (this.busy) return;
    var self = this;
    this.hideMsg();

    // Honeypot: silently "succeed" for bots.
    if (this.hp && this.hp.value) { this.showSuccess(''); return; }

    var email = (this.email.value || '').trim().toLowerCase();
    if (!EMAIL_RE.test(email)) {
      this.email.setAttribute('aria-invalid', 'true');
      this.showMsg('Please enter a valid email address.');
      this.email.focus();
      return;
    }
    var rawPhone = this.phone ? this.phone.value.trim() : '';
    var phone = normalizePhone(rawPhone);
    if (rawPhone && !phone) {
      this.phone.setAttribute('aria-invalid', 'true');
      this.showMsg('Please enter a valid 10-digit US mobile number, or leave it blank.');
      this.phone.focus();
      return;
    }
    var smsOptIn = !!(phone && this.sms && this.sms.checked);

    var key = this.el.getAttribute('data-klaviyo-key') || detectKlaviyoKey();
    if (!key) {
      warn('No Klaviyo public key — set Theme settings → Back in stock alerts → Klaviyo public API key.');
      this.showMsg('Sorry, we couldn’t sign you up right now. Please try again or call us.');
      return;
    }

    var variantId = this.currentId;
    var v = this.variants[variantId];
    var props = this.buildProps(v, phone, smsOptIn);
    var smsList = this.el.getAttribute('data-klaviyo-sms-list');
    var result = { variantId: variantId, email: email, phone: phone || '', smsOptIn: smsOptIn, steps: {} };

    this.setBusy(true);

    var step1 = (smsOptIn && smsList)
      ? klaviyoPost('subscriptions/', key, smsConsentPayload(email, phone, smsList))
          .then(function () { result.steps.smsConsent = 'ok'; return true; })
          .catch(function (e) { warn('SMS consent failed', e.status, e.body || e); result.steps.smsConsent = 'failed'; return false; })
      : Promise.resolve(smsOptIn ? (result.steps.smsConsent = 'skipped:no-list', false) : false);

    step1.then(function (smsOk) {
      var channels = smsOk ? ['EMAIL', 'SMS'] : ['EMAIL'];
      return klaviyoPost('back-in-stock-subscriptions/', key, bisPayload(email, phone, variantId, channels))
        .catch(function (e) {
          if (channels.length > 1) {
            warn('BIS with SMS failed, retrying email-only', e.status, e.body);
            channels = ['EMAIL'];
            return klaviyoPost('back-in-stock-subscriptions/', key, bisPayload(email, phone, variantId, channels));
          }
          throw e;
        })
        .then(function () { result.steps.bis = 'ok'; result.channels = channels; });
    }).then(function () {
      // Best-effort side channels — never block the shopper's success state.
      var uid = 'bis-' + variantId + '-' + email + '-' + new Date().toISOString().slice(0, 10);
      var salesEmail = (self.el.getAttribute('data-sales-alert-email') || DEFAULT_SALES_EMAIL).trim();
      var side = [
        klaviyoPost('events/', key, eventPayload(email, phone, props, uid))
          .then(function () { result.steps.salesEvent = 'ok'; })
          .catch(function (e) { warn('sales event failed', e.status, e.body || e); result.steps.salesEvent = 'failed'; }),
        (salesEmail
          ? klaviyoPost('events/', key, salesLeadPayload(salesEmail, email, phone, props, 'lead-' + uid))
              .then(function () { result.steps.salesLead = 'ok'; })
              .catch(function (e) { warn('sales lead event failed', e.status, e.body || e); result.steps.salesLead = 'failed'; })
          : Promise.resolve(result.steps.salesLead = 'skipped')),
        self.submitHubSpot(email, phone, props)
          .then(function (s) { result.steps.hubspot = s; })
          .catch(function (e) { warn('HubSpot failed', e.status, e.body || e); result.steps.hubspot = 'failed'; })
      ];
      try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'back_in_stock_signup', bis_product: props.ProductName, bis_variant: props.VariantName, bis_variant_id: variantId, bis_sms_opt_in: smsOptIn }); } catch (e) {}

      memStore[variantId] = email;
      writeStore(memStore);
      self.setBusy(false);
      self.showSuccess(email, (result.channels || []).indexOf('SMS') !== -1);
      return Promise.all(side);
    }).then(function () {
      log('subscribed', result);
      self.el.dispatchEvent(new CustomEvent('sven:bis-subscribed', { bubbles: true, detail: result }));
    }).catch(function (e) {
      warn('back-in-stock subscribe failed', e && e.status, e && (e.body || e));
      result.steps.bis = 'failed';
      self.setBusy(false);
      self.showMsg('Sorry, we couldn’t sign you up right now. Please try again in a moment.');
      self.el.dispatchEvent(new CustomEvent('sven:bis-error', { bubbles: true, detail: result }));
    });
  };

  Instance.prototype.submitHubSpot = function (email, phone, props) {
    var el = this.el;
    var portal = el.getAttribute('data-hs-portal');
    var form = el.getAttribute('data-hs-form');
    if (!portal || !form) return Promise.resolve('skipped:not-configured');
    var fields = [{ objectTypeId: '0-1', name: 'email', value: email }];
    if (phone) fields.push({ objectTypeId: '0-1', name: 'phone', value: phone });
    var pProd = el.getAttribute('data-hs-prop-product');
    var pVar = el.getAttribute('data-hs-prop-variant');
    var pUrl = el.getAttribute('data-hs-prop-url');
    if (pProd) fields.push({ objectTypeId: '0-1', name: pProd, value: props.ProductName });
    if (pVar) fields.push({ objectTypeId: '0-1', name: pVar, value: props.VariantName + (props.SKU ? ' (SKU ' + props.SKU + ')' : '') });
    if (pUrl) fields.push({ objectTypeId: '0-1', name: pUrl, value: props.URL });
    var ctx = { pageUri: window.location.href, pageName: document.title };
    var hutk = getCookie('hubspotutk');
    if (hutk) ctx.hutk = hutk;
    return postJSON('https://api.hsforms.com/submissions/v3/integration/submit/' + encodeURIComponent(portal) + '/' + encodeURIComponent(form),
      { fields: fields, context: ctx }).then(function () { return 'ok'; });
  };

  /* ---------- boot ---------- */
  var instances = [];
  function boot() {
    document.querySelectorAll('[data-sven-bis]').forEach(function (el) {
      if (el.__svenBis) return;
      el.__svenBis = new Instance(el);
      instances.push(el.__svenBis);
    });
  }

  window.SvenBIS = {
    __loaded: true,
    boot: boot,
    instances: instances,
    normalizePhone: normalizePhone,
    detectKlaviyoKey: detectKlaviyoKey,
    /** Scroll to + highlight the notify form inside a given PDP root (used by the sticky ATC). */
    focus: function (root) {
      var el = (root || document).querySelector('[data-sven-bis]:not([hidden])');
      if (el && el.__svenBis) { el.__svenBis.focusFirst(); return true; }
      return false;
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
